import { render, staticRenderFns } from "./sort-by.vue?vue&type=template&id=54b85db9&"
import script from "./sort-by.vue?vue&type=script&lang=ts&"
export * from "./sort-by.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports